module.exports = __webpack_public_path__ + "media/tape-nav/commerce-business-upgrade-account-icon-448fc124.svg";